import { z } from 'zod';
import { CustomErrorType, createZodFormResolver, CustomErrorParams, Validation } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';

export enum FormField {
    FirstName = 'firstName',
    LastName = 'lastName',
    AgreeToTermsAndConditions = 'agreeToTermsAndConditions',
    Password = 'password',
    NewPassword = 'newPassword',
}

export interface SignUpFormValues {
    [FormField.FirstName]?: string;
    [FormField.LastName]?: string;
    [FormField.Password]: string;
    [FormField.NewPassword]: string;
    [FormField.AgreeToTermsAndConditions]?: boolean;
}

export const createSignUpResolver = ({
    isProvisionedUser,
    showConsentField,
}: {
    isProvisionedUser?: boolean;
    showConsentField: boolean;
}) => {
    const schema = z
        .object({
            [FormField.Password]: Validation.String.Password,
            [FormField.NewPassword]: z.string(),
            [FormField.FirstName]: isProvisionedUser ? z.string().optional() : Validation.String.Required,
            [FormField.LastName]: isProvisionedUser ? z.string().optional() : Validation.String.Required,
            [FormField.AgreeToTermsAndConditions]: z
                .boolean()
                .optional()
                .refine((val) => (showConsentField ? val === true : true), {
                    params: {
                        errorType: CustomErrorType.Other,
                        textKey: TextKey.ValidateTermsAndConditionsChecked,
                    } satisfies CustomErrorParams,
                }),
        })
        .refine(({ password, newPassword }) => password === newPassword, {
            params: {
                errorType: CustomErrorType.Other,
                textKey: TextKey.PasswordsMustBeTheSame,
            } satisfies CustomErrorParams,
            path: [FormField.NewPassword],
        });

    return createZodFormResolver<SignUpFormValues>(schema);
};
